export { default as FooterCompact } from './FooterCompact'
export type * from './FooterCompact'
export { default as HeaderCompact } from './HeaderCompact'
export type * from './HeaderCompact'
export { default as Footer, LocaleSwitchLink, FooterMobileSectionContent, FooterDesktopSectionContent } from './Footer'
export type { FooterProps, FooterText, Section } from './Footer'
export { default as CookieBanner, useCookieBannerAutoReject } from './CookieBanner'
export type { CookieBannerProps } from './CookieBanner'
export { default as Header } from './Header'
export type * from './Header'
export { default as getDomain } from './shared/getDomain'
export {
  default as MatchingEventBanners,
  type MatchingEventBannersProps,
  type MatchingEventBannersText,
  type MatchingEventCampaignType,
} from './MatchingEventBanners'
export {
  default as UserInfo,
  UserLoginLink,
  UserInfoLoading,
  type UserInfoProps,
  type UserLoginLinkProps,
} from './UserInfo'
